import { Component } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';
import { Pallet } from '../../domain/inventory.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Warehouse } from '../../domain/warehouse.model';
import { Router } from '@angular/router';
import { PalletService } from '../../services/pallet.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InventoryService } from '../../services/inventory.service';
import { MessageHomeService } from '../../services/message-home.service';

@Component({
    selector: 'app-edit-pallet',
    templateUrl: './edit-pallet.component.html',
    styleUrl: './edit-pallet.component.scss',
    providers: [ConfirmationService],
    standalone: false
})
export class EditPalletComponent {
  manualQrCode: string = '';
  private qrSearchSubject = new Subject<string>();
  scannedPallets: Pallet[] = [];
  warehouses: Warehouse[] = [
    {
      id: 1,
      name: 'Bodega Zapopan'
    }
  ];
  selectedWarehouse: string = '';
  palletForm: FormGroup = this.formBuilder.group({
    depth: [0, Validators.required],
    width: [0, Validators.required],
    height: [0, Validators.required],
    notes: [''],
    flooring: [''],
    location: [''],
  });
  submitted: boolean = false;
  flooring: string;
  floorings: string[];
  showEditDialog: boolean = false;
  selectedPallet: Pallet | null = null;

  constructor(private confirmationService: ConfirmationService, private router: Router, private messageService: MessageService,
    private palletService: PalletService, private formBuilder: FormBuilder, private inventoryService: InventoryService,
    private messageHomeService: MessageHomeService
  ) {
    this.selectedWarehouse = this.warehouses[0].name;
    this.qrSearchSubject.pipe(
      debounceTime(1000)
    ).subscribe(result => {
      this.onScanSuccess(result.trim());
      this.manualQrCode = '';
    });
    this.floorings = this.inventoryService.getPalletLocation();
    this.flooring = this.floorings[0];
  }

  onManualInputChange() {
    this.qrSearchSubject.next(this.manualQrCode);
  }

  removeItem(index: number) {
    this.scannedPallets.splice(index, 1);
  }

  onUpdatePallets() {
    this.palletService.updatePallets(this.scannedPallets).subscribe(() => {
      const successMessage = this.scannedPallets.length === 1 ? 'Palet Actualizada' : 'Palets Actualizadas';
      this.messageHomeService.showSuccessAndNavigate(
        this.router,
        '/mobile/menu',
        'Exitoso ',
        successMessage
      );
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
    });
  }

  onSavePallet() {
    const updatedPallet: Pallet = {
      ...this.selectedPallet,
      ...this.palletForm.value
    };
    this.onCloseEdit();
    this.scannedPallets.push(updatedPallet);
    this.messageService.add({ severity: 'success', summary: 'Escaneado', detail: 'Palet agregada' });
  }

  onClose() {
    if (this.scannedPallets.length) {
      this.confirmationService.confirm({
        message: 'Las palets aún no se han actualizado. ¿Deseas salir sin actualizar?',
        header: 'Confirmación',
        acceptLabel: 'Sí',
        rejectLabel: 'No',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.router.navigate(['/mobile/menu']);
        }
      });
    } else {
      this.router.navigate(['/mobile/menu']);
    }
  }

  playSound() {
    const audio = new Audio();
    audio.src = '../../assets/sounds/beepSound2.mp3';
    audio.load();
    audio.play();
  }

  onScanSuccess(qrCode: string) {
    //this.manualQrCode = '';
    this.playSound();
    if (this.scannedPallets.some(pallet => pallet.qrCode === qrCode)) {
      this.messageService.add({ severity: 'warn', summary: 'Código duplicado', detail: 'Este código ya esta en la lista' });
      return;
    }

    this.palletService.existingPalletCode(this.selectedWarehouse, qrCode).subscribe(pallet => {
      if (pallet?.palletId) {
        this.selectedPallet = { ...pallet };
        this.palletForm.reset(pallet);
        this.showEditDialog = true;
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
    });
  }

  get formControl(): any {
    return this.palletForm.controls;
  }

  onCloseEdit() {
    this.showEditDialog = false;
    this.palletForm.reset();
  }

}
